import { ContextRoot } from '@/utils/context-root';
import { UserResponseDto } from '@clearbanc/baus-sdk';
import { computed } from 'vue';

export default (context: ContextRoot) => {
  const ctx = context.root;
  const { getters } = ctx.$store;

  const user = computed<UserResponseDto>(() => getters.user);

  const ownerVerificationStepComplete = computed<boolean>(
    () => !!user.value?.agreedToKyc,
  );

  return {
    ownerVerificationStepComplete,
  };
};
